import styled from 'styled-components'

const NavBar = styled.div`
    display: flex;
    align-items: center;
    margin: 0px 20px;
    & > * {
        margin: 5px 15px;
    }
`

const ButtonStyle = styled.button`
    color: #fff;
`

const CheckboxStyle = styled.input`
    position: relative;
    font-size: 0px;
    width: 23px;
    height: 16px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    cursor: pointer;
    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: calc(100% - 3px * 2);
        border-radius: 8px;
        border: 3px solid var(--light-color);
        background-color: transparent;
    }
    &::before {
        content: '';
        position: absolute;
        top: 0px;
        left: 0px;
        margin: 4px;
        width: 8px;
        height: 8px;
        background-color: var(--light-color);
        border-radius: 50%;
        transition: .2s;
    }
    &:checked:before {
        left: calc(100% - 8px - 2px);
        right: 0;
        transition: .2s;
    }
`

const FormStyle = styled.form`
    margin: 10px;
    padding: 20px;
    background-color: var(--main-bg-color);
    display: flex;
    align-items: start;
    flex-direction: column;
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    transition: var(--theme-change-transition);
    & > *:not(.form_title):not(.form_subtitle):not(:last-child) {
        margin: 0px 0px 20px 0px;
    }
    & .form_title.form_title,
    & .form_subtitle.form_subtitle {
        font-family: var(--font);
        color: var(--main-text-color);
        transition: var(--theme-change-transition);
    }
    & .form_subtitle {
        font-size: var(--fsz-subnormal);
        margin: 10px 0px 20px 0px;
    }
    & > *:last-child {
        /* margin-top: 20px; */
    }
`

const InputStyle = styled.input`
`

const FooterStyle = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 20px 0px;
    color: var(--main-color);
    & > div {
        width: calc(25% - 20px);
        min-width: 250px;
        margin: 0px 10px;
        display: flex;
        flex-direction: column;
        align-items: start;
    }
`

const DropList = styled.div`
    transition: .2s;
    position: relative;
    padding: 10px 0px;
    & > span {
        font-size: var(--fsz-normal);
        letter-spacing: 0.02em;
    }
    & > div {
        position: absolute;
        bottom: 0;
        left: 0px;
        display: flex;
        flex-direction: column;
        background-color: var(--primary-color);
        border-radius: 3px;
        opacity: 0;
        transform-origin: top;
        transition: 0s;
        transition-delay: .1s;
        z-index: -10;
        box-shadow: var(--box-shadow);
        & > a {
            font-size: var(--fsz-subnormal);
            white-space: nowrap;
            user-select: none;
        }
    }
    &:hover > div,
    &:focus > div {
        transform: translateY(100%);
        opacity: 1;
        transition: .2s;
        transition: opacity .3s;
        z-index: -99;
    }
`

const SideBar = styled.div`
    min-width: 150px;
    max-width: 250px;
    display: inline-flex;
    flex-direction: column;
    background-color: var(--primary-color);
    color: var(--light-color);
    padding: 15px;
    margin-right: 20px;
    max-height: calc(100vh - 90px);
    overflow-y: auto;
    & > * {
        margin: 5px 0px;
        padding: 5px;
    }
`

export {
    NavBar,
    ButtonStyle,
    CheckboxStyle,
    InputStyle,
    FormStyle,
    FooterStyle,
    DropList,
    SideBar
}


